import React from 'react'
import { isMobile } from 'react-device-detect'

const BlogPosting = () => {
    const myIframe = document.getElementById("my-iframe");
    if (myIframe) {
        const iframeWindow = myIframe.contentWindow;
        const iframeDocument=myIframe.contentDocument
        // console.log(iframeWindow)
    }
    
    // iframeDocumet.body.style.backgroundColor="transparent"
  return (
      <div>
          {!isMobile && <iframe id="my-iframe" src="https://blog.skyserve.ai/embed" style={{display:"flex",marginTop:"40px",marginLeft:"25%",width:"50%",height:"160px"}}
        frameborder="0" scrolling="no"></iframe>}
        {isMobile && <iframe id="my-iframe" src="https://blog.skyserve.ai/embed" style={{display:"flex",marginTop:"20px",width:"100%",height:"250px"}}
        frameborder="0" scrolling="no"></iframe>}
    </div>
  )
}

export default BlogPosting
